/**
 * Admin auth storage - token, refresh_token and user in localStorage.
 * Keys namespaced to avoid collision with user-facing app.
 * Mirrors digi-gold-web-admin-react auth management.
 */
const TOKEN_KEY = "endosurgery_admin_token";
const REFRESH_TOKEN_KEY = "endosurgery_admin_refresh_token";
const USER_KEY = "endosurgery_admin_user";
const LAST_ACTIVITY_KEY = "endosurgery_admin_last_activity";

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getAdminRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const setAdminRefreshToken = (token) => {
  if (token) localStorage.setItem(REFRESH_TOKEN_KEY, token);
  else localStorage.removeItem(REFRESH_TOKEN_KEY);
};

export const getAdminUser = () => {
  try {
    const s = localStorage.getItem(USER_KEY);
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
};
export const setAdminUser = (user) => {
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  else localStorage.removeItem(USER_KEY);
};

/** Update last activity timestamp (for session tracking) */
export const updateAdminLastActivity = () => {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
  } catch (e) {
    console.warn("Admin last activity update failed:", e);
  }
};

/** Get last activity timestamp */
export const getAdminLastActivity = () => {
  try {
    const v = localStorage.getItem(LAST_ACTIVITY_KEY);
    return v ? parseInt(v, 10) : null;
  } catch {
    return null;
  }
};

export const clearAdminAuth = () => {
  setAdminToken(null);
  setAdminRefreshToken(null);
  setAdminUser(null);
  try {
    localStorage.removeItem(LAST_ACTIVITY_KEY);
  } catch (_) {}
};
export const isAdminAuthenticated = () => Boolean(getAdminToken());
